<template>
  <v-container
    id="movimentacao-leite-form"
    fluid
    tag="section"
  >
    <!-- FORMULARIO DE USUARIO NAO IDENTIFICADO -->
    <usuario-nao-identificado-form
      v-if="!usuarioIdentificado"
      :titulocard="$t('movimentacao-leite')"
    />

    <base-material-card
      v-else
      color="primary"
      icon="mdi-cash-check"
      :title="$t('movimentacao-leite')"
      :app-online="appOnline"
    >
      <v-row>
        <v-col
          cols="12"
          lg="12"
        >
          <div>
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="pesquisar"
            >
              <v-row>
                <v-col
                  cols="12"
                  lg="8"
                  class="d-flex align-center"
                >
                  <v-select
                    v-model="anoFiltro"
                    :items="yearOptions"
                    :success="true"
                    label="Ano"
                    @change="updateSelectedAno"
                  />
                  <v-btn
                    class="ml-2"
                    elevation="1"
                    fab
                    small
                    color="primary"
                    type="submit"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <v-skeleton-loader
            v-if="loading"
            height="250"
            type="table-tbody"
          />
          <v-data-table
            v-if="movimentacoes.length > 0"
            :headers="titulosMovimentacao"
            :items="movimentacoes"
            :items-per-page="5"
            disable-pagination
            hide-default-footer
            disable-sort
          >
            <template v-slot:[`item.nomePropriedade`]="{ item }">
              <v-label class="primary--text">
                {{ item.nomePropriedade }}
              </v-label>
            </template>
            <template v-slot:[`item.endereco`]="{ item }">
              <v-label class="primary--text">
                {{ item.endereco }}
              </v-label>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <v-btn
                class="px-2 ml-1"
                min-width="0"
                color="primary"
                @click="ExibeListaMovimentacao(item)"
              >
                Detalhar
              </v-btn>
            </template>
          </v-data-table>
          <div v-else-if="dadosnaoencontrados">
            <p>Dados não encontrados</p>
          </div>
        </v-col>
        <dashboard-core-snackbar
          v-model="snackbar.visible"
          :visible="snackbar.visible"
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          :message="snackbar.message"
        />
        <lista-movimentacao-form
          :movimentacao="movimentacaoSelecionada"
          :exibedialog="dialog"
          @update-dialog="updateDialog"
        />
      </v-row>
    </base-material-card>
  </v-container>
</template>
  <script>
  import MovimentacaoLeiteService from '../../../services/movimentacaoleiteservice'
  import utils from '../../../services/utils'
  export default {
    name: 'DashboardFormsMovimentacaoLeiteForm',

    components: {
      DashboardCoreSnackbar: () => import('../components/core/Snackbar'),
      ListaMovimentacaoForm: () => import('../forms/ListaMovimentacaoLeiteForm'),
      UsuarioNaoIdentificadoForm: () => import('./UsuarioNaoIdentificadoForm'),
    },
    mixins: [utils],
    data: () => ({
      valid: true,
      appOnline: navigator.onLine,
      usuarioIdentificado: true,
      loading: false,
      dialog: false,
      disabledSelectLaticinio: true,
      idLaticinio: 0,
      idProdutor: 0,
      idMovimentacao: 0,
      laticinioLabel: 'Laticínio',
      listaLaticinios: [],
      movimentacoes: [],
      listaMovimentacao: [],
      titulosMovimentacao: [
        { text: 'Propriedade', sortable: true, value: 'nomePropriedade' },
        { text: 'Endereço', sortable: true, value: 'endereco' },
        { text: '', align: 'end', sortable: true, value: 'id' },
      ],
      anoFiltro: new Date().getFullYear().toString(),
      laticinioSelecionado: {},
      movimentacaoSelecionada: {},
      empresaMovimentacao: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      dadosnaoencontrados: false,
    }),
    computed: {
      yearOptions () {
        const currentYear = new Date().getFullYear()
        return Array.from({ length: 101 }, (_, index) => String(currentYear - index))
      },
    },
    watch: {
      anoFiltro () {
        this.movimentacoes = []
        // this.pesquisar()
      },
    },

    mounted () {
      if (localStorage.chaveativacao && localStorage.chaveativacao !== 'undefined') {
        this.chaveativacao = localStorage.chaveativacao
        if (localStorage.getItem('usuarioIdentificado') && localStorage.getItem('usuarioIdentificado') === 'true') {
          this.usuarioIdentificado = true
          this.carregaForm()
        } else {
          this.usuarioIdentificado = false
        }
      } else {
        localStorage.clear()
        this.$router.push('/pages/usuarioprodutor')
      }
    },

    methods: {
      carregaForm () {
        this.pesquisar()
      },
      pesquisar () {
        this.dialog = false
        this.carregaMovimentacaoLeite(this.anoFiltro)
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      updateSelectedId (selectedId) {
        this.idLaticinio = selectedId
      },
      updateSelectedAno (selectedAno) {
        this.anoFiltro = selectedAno
        // this.carregaMovimentacaoLeite(this.anoFiltro)
      },
      updateDialog (dialog) {
        this.dialog = dialog
      },
      carregaMovimentacaoLeite (ano) {
        this.loading = false

        MovimentacaoLeiteService.listarMovimentacao(ano, localStorage.chaveativacao).then(resposta => {
          this.appOnline = true
          this.movimentacoes = resposta.data
          this.loading = false

          if (this.movimentacoes[0] === null) {
            this.dadosnaoencontrados = true
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listar movimentacao(): ' + e.response)
            this.$router.push('/')
          }
          this.loading = false
        })
      },
      ExibeListaMovimentacao (movimentacao) {
        this.movimentacaoSelecionada = movimentacao
        this.listaMovimentacao = movimentacao.ListaMovimentacaoLeite.map((item) => {
          return ({
            contratoId: item.contratoId,
            diversos: this.parseMoeda(item.diversos, 4),
            frete: this.parseMoeda(item.frete, 2),
            funruralsenar: this.parseMoeda(item.funrural + item.senar, 2),
            id: item.id,
            listamovimentacaoId: item.listamovimentacaoId,
            litros: item.litros,
            mes: item.mes,
            movimentacaoLeite: this.parseMoeda(item.movimentacaoLeite, 2),
            valorBruto: this.parseMoeda(item.valorBruto, 2),
            veterinaria: this.parseMoeda(item.veterinaria, 2),
          })
        })

        this.dialog = true
      },
      parseMoeda (valor, casasdecimais) {
        if (!valor || valor === 0) {
          return '0,00'
        } else {
          valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: casasdecimais })
          return valor
        }
      },
      salvaDadosOffline () {
      },
      carregaDadosOffline () {
      },
      carregaLaticinios () {
        this.idLaticinio = 0
        this.loading_laticinios = true
        MovimentacaoLeiteService.listarLaticinios(localStorage.chaveativacao).then(resposta => {
          this.movimentacoes = resposta.data
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.carregaDadosOffline()
          } else {
            console.log('Erro listarLaticinios(): ' + e.response)
            this.$router.push('/')
          }
          this.loading_laticinios = false
        })
      },
    },
  }
  </script>

  <style scoped>
    .v-data-table table thead tr th {font-weight: 400;}
    .theme--light.v-label {
      color: rgba(0, 0, 0, 0.7);
    }
  </style>
